var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-section-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle, icon: "magicon-tiles" } },
        [
          _vm.$can("MUTATE_SECTIONS")
            ? _c(
                "ui-button",
                {
                  attrs: { color: "positive", loading: _vm.submitting },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.form.submit()
                    },
                  },
                },
                [_vm._v("Opslaan")]
              )
            : _vm._e(),
          _vm.sectionId && _vm.$can("MUTATE_SECTIONS")
            ? _c(
                "ui-button",
                {
                  attrs: { color: "negative", icon: "magicon-trash" },
                  on: { click: _vm.deleteSection },
                },
                [_vm._v("Verwijderen")]
              )
            : _vm._e(),
          _c(
            "ui-button",
            {
              attrs: { slot: "left", color: "medium", type: "bordered" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-dropdown", {
            attrs: {
              searchable: "",
              title: "Perceel",
              name: "parcelId",
              options: _vm.parcelOptions,
              rules: "required",
            },
            model: {
              value: _vm.pendingSection.parcelId,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSection, "parcelId", $$v)
              },
              expression: "pendingSection.parcelId",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Naam", name: "name", rules: "required" },
            model: {
              value: _vm.pendingSection.name,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSection, "name", $$v)
              },
              expression: "pendingSection.name",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              title: "Oppervlakte (ha)",
              name: "size",
              rules: "required",
              decimal: "",
              hint:
                _vm.availableSize != null
                  ? `Beschikbare oppervlakte: ${_vm.formattedAvailableSize} ha`
                  : null,
            },
            model: {
              value: _vm.pendingSection.size,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSection, "size", $$v)
              },
              expression: "pendingSection.size",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }